import styled, { css, SimpleInterpolation } from 'styled-components';

import FadeInOutRouteWrap from 'ggApp/shared/components/FadeInOutRouteWrap';
import LayoutComponentContentWrap from 'ggApp/shared/components/layout/contentWrap';
import HeaderComponent from 'ggApp/shared/components/Header';

export const FadeInOutWrap = styled(FadeInOutRouteWrap)`
    flex: 1 1 auto;
`;

export const LayoutWrap = styled(LayoutComponentContentWrap)<{ $minHeight?: number }>`
    display: flex;
    flex-direction: column;

    ${(props): SimpleInterpolation => css`
        min-height: ${props.$minHeight ? `${props.$minHeight}px` : 'unset'};
        background: ${props.theme.colors.Background};
    `}
`;

export const Header = styled(HeaderComponent)`
    padding-bottom: 0;
`;
